/* eslint-disable dot-notation */
import React from 'react';
import SvgIcon from '../svg-icon';

import styles from './styles.scss';
import LytTooltip from '../../library/tooltip/LytTooltip';

const info = ({ message, type = 'info', forDescription = false, forHeading = false }) =>
    <div className={styles['info']}>
        <LytTooltip
            content={message}
            position={forDescription ? 'bottom' : forHeading ? 'bottom' : 'bottom'}
        >
            <div className={styles['info__icon']}>
                <SvgIcon type={type} />
            </div>
        </LytTooltip>
    </div>
    ;

export default info;
